import { FilterTemplate } from '@repo/shared/dtos/beneficiary'
import { Button } from '@repo/ui/button'
import { useT } from '@repo/ui/hooks'
import { TooltipWrapper } from '@repo/ui/tooltip'
import { Maximize2Icon } from 'lucide-react'
import { useCallback } from 'react'

import { useBeneficiaryListAsSheet } from '@/components/beneficiary/list/sheet/hook'
import { useWidgets } from '@/components/dashboard/widgets/hook'
import { Widget } from '@/components/dashboard/widgets/Widget'
import { getWidgetData } from '@/store/dashboard-widgets/thunks'
import { DashboardWidget } from '@/store/dashboard-widgets/types'
import { useStoreDispatch } from '@/store/hooks'

export function WidgetList() {
  const dispatch = useStoreDispatch()
  const { tc } = useT()
  const { setOpen } = useBeneficiaryListAsSheet()
  const handleOpen = useCallback(
    (filterTemplate: FilterTemplate) => () => setOpen(true, { filterTemplate }),
    [],
  )
  const handleForceRefresh = useCallback(
    (widget: DashboardWidget) => () =>
      void dispatch(getWidgetData({ widget, cacheOptions: { forceReset: true } })),
    [],
  )
  const { reorderedWidgets } = useWidgets()
  return (
    <>
      {reorderedWidgets.map((widget) => (
        <Widget
          key={widget.filterTemplate.id}
          widget={widget}
          onForceRefresh={handleForceRefresh(widget)}
        >
          <TooltipWrapper content={tc('open', { cfl: true })}>
            <Button size="icon" variant="ghost" onClick={handleOpen(widget.filterTemplate)}>
              <Maximize2Icon className="size-4" />
            </Button>
          </TooltipWrapper>
        </Widget>
      ))}
    </>
  )
}
